"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "59", height: "53", viewBox: "0 0 59 53", className: "Icon help-center", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement("path", { id: "a-help-center", d: "M41 14.5V0H5v48h36V36.75z" })
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { stroke: "#979797", d: "M30.442 6L35 13.287V52H1V6h29.442z", strokeWidth: "2" }),
            _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#a-help-center" }),
            _react2.default.createElement("path", { stroke: "#979797", d: "M40 47H6V1h34v46z", strokeWidth: "2" }),
            _react2.default.createElement(
                "g",
                { stroke: "#979797", transform: "translate(29 13)", strokeWidth: "2" },
                _react2.default.createElement("circle", { cx: "11", cy: "11", r: "11" }),
                _react2.default.createElement("path", { d: "M21.232 16.49l6.486 6.485a3 3 0 1 1-4.243 4.243l-6.486-6.486 4.243-4.243z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/help-center.js
// module id = 1806
// module chunks = 0